(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[72852,93812,49105],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 65300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paginator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/components/Paginator/utils/usePaginator.js


var usePaginator = function(param) {
    var pagesCounter = param.pagesCounter, currentPage = param.currentPage, pageSlug = param.pageSlug, className = param.className;
    var previous = "", next = "";
    var ref = (0,router.useRouter)(), _query = ref.query, category = _query.slug;
    if (currentPage > 3) previous = pagesCounter > 4 ? "start" : "";
    if (currentPage <= pagesCounter - 3) next = pagesCounter > 5 ? "next" : "";
    var pushRouter = function(currentCategory, nextPage) {
        var ref = constants/* ROUTES */.y2[pageSlug].getRoute(currentCategory, nextPage), path = ref.path, dynamicPath = ref.dynamicPath;
        window.scrollTo(0, 0);
        router_default().push({
            pathname: dynamicPath
        }, {
            pathname: path
        });
    };
    var handleOnPreviousClick = function() {
        return pushRouter(category, 1);
    };
    var handleOnPageClick = function(param) {
        var selected = param.selected;
        return pushRouter(category, selected + 1);
    };
    return {
        previous: previous,
        next: next,
        pagesCounter: pagesCounter,
        currentPage: currentPage,
        className: className,
        handleOnPageClick: handleOnPageClick,
        handleOnPreviousClick: handleOnPreviousClick
    };
};

// EXTERNAL MODULE: ./UI/components/Paginator/styles.module.scss
var styles_module = __webpack_require__(35398);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Paginator/index.jsx






var Paginator = function(props) {
    var ref = usePaginator(props), previous = ref.previous, next = ref.next, pagesCounter = ref.pagesCounter, currentPage = ref.currentPage, className = ref.className, handleOnPageClick = ref.handleOnPageClick, handleOnPreviousClick = ref.handleOnPreviousClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).paginationWrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).paginationPrev,
                onClick: handleOnPreviousClick,
                role: "button",
                tabIndex: "0",
                children: previous
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                pageCount: pagesCounter,
                pageRangeDisplayed: 4,
                marginPagesDisplayed: 0,
                nextLabel: next,
                containerClassName: (styles_module_default()).paginationContainer,
                pageClassName: (styles_module_default()).paginationItem,
                pageLinkClassName: (styles_module_default()).paginationLink,
                activeClassName: (styles_module_default()).paginationActiveClassName,
                activeLinkClassName: (styles_module_default()).paginationActiveLink,
                breakClassName: (styles_module_default()).paginationEmptyItem,
                breakLinkClassName: (styles_module_default()).paginationEmptyLink,
                previousClassName: (styles_module_default()).previousClassName,
                nextClassName: (styles_module_default()).paginationNextWrapper,
                nextLinkClassName: (styles_module_default()).paginationNext,
                disableInitialCallback: true,
                forcePage: currentPage - 1,
                onPageChange: handleOnPageClick
            })
        ]
    });
};
Paginator.defaultProps = {
    className: ""
};
Paginator.propTypes = {
    pagesCounter: (prop_types_default()).number.isRequired,
    currentPage: (prop_types_default()).number.isRequired,
    pageSlug: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_Paginator = (Paginator);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 63111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ArticlesList; },
  "Z": function() { return /* binding */ BlogCommon_ArticlesList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./components/Common/ArticlePreview/styles.module.scss
var styles_module = __webpack_require__(25999);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/ArticlePreview/index.jsx













var ArticlePreview = function(param) {
    var slug = param.slug, title = param.title, image = param.image, tags = param.tags, introduction = param.introduction, date = param.date, type = param.type, index = param.index, isSearch = param.isSearch, handleOnCloseModalWindow = param.handleOnCloseModalWindow;
    var path = constants/* ROUTES.article.getRoute */.y2.article.getRoute(slug).path;
    var articleLinkProps = {
        path: path
    };
    if (!slug || !title || !image) {
        return null;
    }
    var handleOnArticleClick = function() {
        if (isSearch) {
            handleOnCloseModalWindow();
        }
    };
    var imageSizes = index === 0 ? {
        width: 720,
        height: 428
    } : {
        width: 297,
        height: 223
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: classnames_default()((styles_module_default())[type], (0,_define_property/* default */.Z)({}, (styles_module_default()).medium, index === 0)),
        onClick: handleOnArticleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
            className: (styles_module_default()).card,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        src: image,
                        alt: title,
                        layout: "responsive"
                    }, imageSizes), {
                        scale: 2,
                        className: (styles_module_default()).imgContainer
                    }))
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).articleContent,
                    children: [
                        date && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (styles_module_default()).date,
                            children: (0,helper/* formatDate */.p6)(date)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                            className: (styles_module_default()).articlePreviewTitle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (styles_module_default()).title,
                                children: title
                            })
                        })),
                        introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, articleLinkProps), {
                            className: (styles_module_default()).articlePreviewIntroduction,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).introduction,
                                children: introduction
                            })
                        })),
                        (tags === null || tags === void 0 ? void 0 : tags.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).tags,
                            children: (tags || []).filter(function(param) {
                                var tagSlug = param.slug;
                                return isSearch || constants/* VALUABLE_ARTICLE_CATEGORIES_SLUGS.includes */.Sk.includes(tagSlug);
                            }).map(function(param) {
                                var tagSlug = param.slug;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: routes/* routes.blog.getRoute */._.blog.getRoute(tagSlug).path,
                                    className: (styles_module_default()).tag,
                                    children: "#".concat(tagSlug.replaceAll("-", ""))
                                });
                            })
                        })
                    ]
                })
            ]
        })
    });
};
ArticlePreview.defaultProps = {
    introduction: "",
    date: "",
    isSearch: false,
    index: 1,
    handleOnCloseModalWindow: function() {}
};
ArticlePreview.propTypes = {
    slug: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    image: (prop_types_default()).string.isRequired,
    category: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string.isRequired,
    introduction: (prop_types_default()).string,
    date: (prop_types_default()).string,
    index: (prop_types_default()).number,
    isSearch: (prop_types_default()).bool,
    handleOnCloseModalWindow: (prop_types_default()).func,
    animatioProps: prop_types_default().instanceOf(Object).isRequired
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/Cards/BlogSubscribeCard/BlogSubscribeCard.module.scss
var BlogSubscribeCard_module = __webpack_require__(94513);
var BlogSubscribeCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogSubscribeCard_module);
;// CONCATENATED MODULE: ./UI/components/Cards/BlogSubscribeCard/index.jsx






var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var BlogSubscribeCard = function(param) {
    var toggleFullscreenSubscribe = param.toggleFullscreenSubscribe;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
        className: (BlogSubscribeCard_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: "processLaunch",
                className: (BlogSubscribeCard_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                className: (BlogSubscribeCard_module_default()).titleSection,
                title: "Subscribe",
                secondTitle: "to new posts",
                secondDescription: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                onClick: toggleFullscreenSubscribe,
                children: "Subscribe"
            })
        ]
    });
};
/* harmony default export */ var Cards_BlogSubscribeCard = (BlogSubscribeCard);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./components/BlogCommon/ArticlesList/utils/propsHelper.js




function getAnimationProps() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _index = ref.index, index = _index === void 0 ? 1 : _index, _isSearch = ref.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, _isMobileResolution = ref.isMobileResolution, isMobileResolution = _isMobileResolution === void 0 ? false : _isMobileResolution;
    var delay = isSearch ? 30 * index : 100 + 50 * index;
    var animatioProps = isSearch ? {
        type: constants/* ANIMATED_TYPE.isFade */.BK.isFade,
        delay: delay,
        duration: 200,
        distance: "1rem",
        bottom: true,
        effect: "fadeInUp"
    } : {
        type: constants/* ANIMATED_TYPE.isCustom */.BK.isCustom,
        translateY: "1.5em",
        opasityDuration: 1,
        transformDuration: 1,
        transitionDelay: delay
    };
    if (isMobileResolution) {
        animatioProps = {
            type: constants/* ANIMATED_TYPE.isCustom */.BK.isCustom,
            translateY: "0.05em",
            opasityDuration: 0.05,
            transformDuration: 0.05,
            transitionDelay: 100
        };
    }
    return animatioProps;
}
function getArticleProps() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, article = ref.article, _isSearch = ref.isSearch, isSearch = _isSearch === void 0 ? false : _isSearch, _isMobileResolution = ref.isMobileResolution, isMobileResolution = _isMobileResolution === void 0 ? false : _isMobileResolution, _index = ref.index, index = _index === void 0 ? 1 : _index;
    var previewImage = get_default()(article, "previewImageUrl.url");
    var animatioProps = getAnimationProps({
        isSearch: isSearch,
        isMobileResolution: isMobileResolution,
        index: index
    });
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, article), {
        previewImage: previewImage,
        animatioProps: animatioProps
    });
}

// EXTERNAL MODULE: ./components/BlogCommon/ArticlesList/styles.module.scss
var ArticlesList_styles_module = __webpack_require__(99235);
var ArticlesList_styles_module_default = /*#__PURE__*/__webpack_require__.n(ArticlesList_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/ArticlesList/index.jsx










var ArticlesList = function(param) {
    var articles = param.articles, isSearch = param.isSearch, isBlogPage = param.isBlogPage, currentPage = param.currentPage, handleOnCloseModalWindow = param.handleOnCloseModalWindow, toggleFullscreenSubscribe = param.toggleFullscreenSubscribe;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var articleType = isSearch ? constants/* ARTICLE_PREVIEW_TYPES.search */.p_.search : constants/* ARTICLE_PREVIEW_TYPES.blog */.p_.blog;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ArticlesList_styles_module_default()).articlesList),
        children: articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
            var ref;
            var articleProps = getArticleProps({
                article: article,
                index: index,
                isSearch: isSearch,
                isMobileResolution: isMobileResolution
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    currentPage === 1 && isBlogPage && index === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_BlogSubscribeCard, {
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePreview, {
                        type: articleType,
                        index: index,
                        animatioProps: articleProps.animatioProps,
                        slug: articleProps.slug,
                        title: articleProps.title,
                        tags: (ref = articleProps.tagsListCollection) === null || ref === void 0 ? void 0 : ref.items,
                        introduction: articleProps.introduction,
                        image: articleProps.previewImage,
                        date: articleProps.publishedAt,
                        isSearch: isSearch,
                        handleOnCloseModalWindow: handleOnCloseModalWindow
                    }, articleProps.title)
                ]
            });
        })
    });
};
ArticlesList.defaultProps = {
    isSearch: false,
    isBlogPage: false,
    handleOnCloseModalWindow: function() {}
};
ArticlesList.propTypes = {
    articles: prop_types_default().instanceOf(Array).isRequired,
    isSearch: (prop_types_default()).bool,
    isBlogPage: (prop_types_default()).bool,
    currentPage: (prop_types_default()).number.isRequired,
    handleOnCloseModalWindow: (prop_types_default()).func,
    toggleFullscreenSubscribe: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_ArticlesList = (ArticlesList);


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 94513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogSubscribeCard_card__n8ljy","image":"BlogSubscribeCard_image__al6_I","titleSection":"BlogSubscribeCard_titleSection__mbdDN"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 35398:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"styles_paginationWrapper__3DhNo","paginationContainer":"styles_paginationContainer__087V2","paginationPrev":"styles_paginationPrev__bR_JQ","paginationItem":"styles_paginationItem__0UD3l","paginationNextWrapper":"styles_paginationNextWrapper__n3tXg","paginationNext":"styles_paginationNext__BVMd0","paginationActiveClassName":"styles_paginationActiveClassName__96uLh","previousClassName":"styles_previousClassName__FqecZ","paginationEmptyItem":"styles_paginationEmptyItem__NWkl9"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 99235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"locationSubscribe":"styles_locationSubscribe__lqgd8","articlesList":"styles_articlesList__DclDg","blinking":"styles_blinking__Htl9p","swing":"styles_swing__qoiyt","animateborder":"styles_animateborder__qm_os","animateborder-overlay":"styles_animateborder-overlay__zwze2","animatecircle":"styles_animatecircle__D3mfx","animatedot":"styles_animatedot__W4oZ0","animStar":"styles_animStar__E1V34","hideText":"styles_hideText___NNWU","spin":"styles_spin__aP4Vl","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__pOhqI","outOfTransparencyMobile":"styles_outOfTransparencyMobile__JBGCL","appearance":"styles_appearance__3FmsH","appearanceFromBelow":"styles_appearanceFromBelow__CxpsV","flicker":"styles_flicker__w0Erh","vibrate1":"styles_vibrate1__dIlEp","rocket":"styles_rocket__mCgKA","burgerItem1":"styles_burgerItem1__t9_LV","burgerItem2":"styles_burgerItem2__V5aXs","burgerItem3":"styles_burgerItem3__SDZVH","burgerItem1Reverse":"styles_burgerItem1Reverse__nprsZ","burgerItem2Reverse":"styles_burgerItem2Reverse__zhzHs","burgerItem3Reverse":"styles_burgerItem3Reverse__FOc34","arrow-down":"styles_arrow-down__amOOi","image-scroll":"styles_image-scroll__fKa6G","image-scroll-reverse":"styles_image-scroll-reverse__sm2Pg","stickerbox-pointer-move":"styles_stickerbox-pointer-move__ecAd0","hide-image":"styles_hide-image__wYz6r","stickerbox-pointer-second":"styles_stickerbox-pointer-second__i6CPW","stickerbox-pointer-third":"styles_stickerbox-pointer-third__lGt4e","cedar-bounce":"styles_cedar-bounce__ivdPy"};

/***/ }),

/***/ 25999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__dAKTy","articlePreview":"styles_articlePreview__QGB75","blogCard":"styles_blogCard__N4Rwm","search":"styles_search__WoQeu","blog":"styles_blog__Oy1V7","related":"styles_related__OGlZK","articleImage":"styles_articleImage__ZaTm8","articleTitle":"styles_articleTitle__KYGJn","title":"styles_title__jzA_t","blogArticleContent":"styles_blogArticleContent__5xlVF","articlePreviewTitle":"styles_articlePreviewTitle__PDqtq","articleContent":"styles_articleContent__R_gLn","tags":"styles_tags__Mg3NQ","tag":"styles_tag__W67ll","category":"styles_category__G3Qas","date":"styles_date__X2hv_","articlePreviewIntroduction":"styles_articlePreviewIntroduction__b2G1Q","introduction":"styles_introduction__8gMO9","imgContainer":"styles_imgContainer___gHpw","medium":"styles_medium__3slxw"};

/***/ })

}]);